<template>
  <div class="dragging-indication">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
</template>

<script>
/**
 * Visual indication to spot something as draggable
 */

export default {
  name: 'DraggingIndication',
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.dragging-indication {
  $dotWidth: 3px;
  $dotMargin: 2px;
  $width: .4rem;

  display: flex;
  flex-flow: row wrap;
  width: calc(#{$dotWidth} * 3);

  > div {
    opacity: 0.5;
    background: $color-shizen-blue;
    width: $dotWidth;
    height: $dotWidth;
    border-radius: 100px;
    margin-bottom: $dotMargin;

    &:nth-child(odd) {
      margin-right: $dotMargin;
    }
  }
}
</style>
